// extracted by mini-css-extract-plugin
export default {"oosNotify":"R7-z","count":"S7-z","otherColors":"T7-z","modalContent":"U7-z","body":"V7-z"};